import { getAll as getAllParametre } from '@/api/parametre/index';

// Renvoi la liste des correspondant au paramètre,
// si liste est queryCreation la fonction créer le paramètrage et renvoi la liste après
export default async function gestionParametre(parametre, liste, queryCreation) {
  if (liste && Array.isArray(liste) && liste.length > 0 && queryCreation && typeof queryCreation === 'function') {
    const promises = liste.filter(l => l).map(l => queryCreation(l));
    await Promise.all(promises);
  }
  const items = (await getAllParametre(parametre)).data.result.items;
  return items;
}
